export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Medium-434686c4f1196b507ba098d07baa0393.woff2";